module.exports = __webpack_public_path__ + "static/media/Placaj ceramic Klinker Dakar.781bb8aa.jpg";